import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {forgotPassword} from "../../utils/API"
class ForgotPasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {email: ''};
        this.handleChangeFormElement = this.handleChangeFormElement.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

    handleChangeFormElement(evt) {
        const value = evt.target.value;
        if(evt.target.name ==='agreePolicy'|| evt.target.name ==='noNewsLetter'){
          const { checked } = evt.target
          this.setState({[evt.target.name]: checked});
        }else{
          this.setState({[evt.target.name]: value});
        }
    }
  
    handleSubmit(event) {
        event.preventDefault();
        forgotPassword(this.state)
         }


    render() {
        return (
            <form id="contact-form" onSubmit={this.handleSubmit}>
                <div className="messages" />
                <div className="form-group">
                <input id="form_email" type="email" name="email" className="form-control"  onChange={this.handleChangeFormElement}  placeholder="Email" required="required" data-error="Valid email is required." />
                <div className="help-block with-errors" />
                </div>
                <button type="submit"  className="btn btn-primary btn-block">Réinitialiser de mon mot de passe</button>
            </form>
        );
    }
}

export default ForgotPasswordForm;